import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const skierMiddlePath: PathObjectInterface = {
  mainPath: { x: 1776, y: 767 },
  spline: [
    1776, 767, 1768, 892, 1785, 961, 1800, 1041, 1845, 1127, 1908, 1199, 1941, 1245, 2037, 1317,
    2109, 1374, 2157, 1463, 2176, 1549, 2198, 1681, 2179, 1799, 2107, 1890, 2008, 1986, 1886, 2065,
  ],
}
